import React from 'react';
import PropTypes from 'prop-types';

import { EMAIL_REGEX, CONTACT_NUMBER_REGEX, NRIC_REGEX, PASSWORD_REGEX } from 'utils/regex';

import Input from '../Input';
import FormItem from 'components/FormItem/FormItem';

const generateExtraGeneralRules = ({ isEmail, isContactNumber, isNRIC, isNewPassword }) => {
  let extraGeneralRules = [];

  if (isEmail) {
    extraGeneralRules.push({
      pattern: EMAIL_REGEX,
      message: 'Please enter a valid email address in lowercase. Eg: example@mail.com'
    });
  }

  if (isContactNumber) {
    extraGeneralRules.push({
      pattern: CONTACT_NUMBER_REGEX,
      message: 'Please enter a valid contact number.'
    });
  }

  if (isNRIC) {
    extraGeneralRules.push({
      pattern: NRIC_REGEX,
      message: `NRIC must only contain 12 numbers without hyphen '-'.`
    });
  }

  if (isNewPassword) {
    extraGeneralRules.push({
      pattern: PASSWORD_REGEX,
      message: `Password must be 8-20 alphanumeric`
    });
  }

  return extraGeneralRules;
};

const FormInput = ({
  noStyle,
  type,
  name,
  label,
  labelSize,
  placeholder,
  prefix,
  autoComplete,
  maxLength,
  size,

  requiredErrorMessage,
  extraRules,

  isEmail,
  isContactNumber,
  isNRIC,
  isNewPassword,
  isDisabled,

  onChange,
  ...props
}) => {
  const extraGeneralRules = generateExtraGeneralRules({ isEmail, isContactNumber, isNRIC, isNewPassword });

  return (
    <FormItem
      noStyle={noStyle}
      name={name}
      label={label}
      labelSize={labelSize}
      requiredErrorMessage={requiredErrorMessage}
      extraRules={[...extraRules, ...extraGeneralRules]}
      {...props}
    >
      <Input
        type={type}
        autoComplete={autoComplete}
        placeholder={placeholder}
        prefix={prefix}
        isDisabled={isDisabled}
        maxLength={maxLength}
        size={size}
        onChange={onChange}
        {...props}
      />
    </FormItem>
  );
};

FormInput.propTypes = {
  extraRules: PropTypes.array,
  maxLength: PropTypes.number,
  size: PropTypes.oneOf(['large', 'middle', 'small']),
  isEmail: PropTypes.bool,
  isContactNumber: PropTypes.bool
};

FormInput.defaultProps = {
  extraRules: [],
  size: 'middle',
  isEmail: false,
  isContactNumber: false
};

export default FormInput;
